// Editor butir survei (PR #108) -- fungsi murni (diuji surveiEditor.test.js). Semua perubahan MEMBUAT data baru (tidak
// mengubah array/objek lama). Validasi di sini hanya cermin cepat utk layar; penentu akhir tetap server
// (backend/survei_versi.py periksa_versi_rinci) yg mengembalikan galat per baris saat simpan/kunci.

export const TEKS_BUTIR_MAKS = 500;
export const BUTIR_MAKS = 200;
export const LABEL_MAKS = 30;
export const CATATAN_TAMBAHAN_MAKS = 1000;
export const TEKS_TERBUKA_MAKS = 2000;
export const LABEL_TB_MAKS = 8;
export const KETERANGAN_TB_MAKS = 200;
// Cermin survei.OPSI_TB_BAWAAN (versi tanpa field opsi_tb, mis. V1 = TB aktif dgn label & keterangan ini).
export const OPSI_TB_BAWAAN = { aktif: true, label: "TB", keterangan: "Tidak Berlaku" }; // = SV.TEKS_TERBUKA_MAKS (batas isian peserta, utk pratinjau formulir)
const POLA_LABEL = /^[A-Za-z0-9_-]{1,30}$/;
const POLA_HTML = /<\s*[/!a-zA-Z]/;
// eslint-disable-next-line no-control-regex
const POLA_KONTROL = /[\u0000-\u001f\u007f-\u009f]/;

export const PESAN_KUNCI_VERSI = "Setelah dikunci, versi tidak dapat diubah; revisi dibuat lewat Salin ke draf baru.";
export const PESAN_KONFLIK = "Draf diubah orang lain atau sudah terkunci. Muat ulang untuk melihat isi terbaru; perubahan Anda di layar belum tersimpan.";

let urut = 0;
export const kunciBaru = () => `b${Date.now().toString(36)}${(urut += 1).toString(36)}${Math.random().toString(36).slice(2, 6)}`;

// Dokumen versi dari server -> isian editor.
export function drafKeEditor(doc) {
    return {
        nama: doc.nama || "",
        label: doc.label || "",
        dimensi: [...(doc.dimensi || [])].sort((a, b) => a.urutan - b.urutan)
            .map((d) => ({ kode: d.kode, nama: d.nama, nama_excel: d.nama_excel, urutan: d.urutan })),
        butir: [...(doc.butir || [])].sort((a, b) => a.nomor - b.nomor)
            .map((b) => ({ kunci: b.kunci || kunciBaru(), dimensi_kode: b.dimensi_kode, teks: b.teks, kalimat_negatif: !!b.kalimat_negatif,
                           boleh_tb: b.boleh_tb !== false })),
        terbuka: (doc.terbuka || []).map((t) => ({ kode: t.kode, label: t.label })),
        catatan_tambahan: doc.catatan_tambahan || "",
        opsi_tb: { ...OPSI_TB_BAWAAN, ...(doc.opsi_tb || {}) },
    };
}

// Isian editor -> body PUT /survei/versi-butir/{id}.
export const editorKeKirim = (isi, rev) => ({
    rev, nama: isi.nama, label: isi.label,
    dimensi: isi.dimensi.map(({ kode, nama, nama_excel }) => ({ kode, nama, nama_excel })),
    butir: isi.butir.map(({ kunci, dimensi_kode, teks, kalimat_negatif, boleh_tb }) => ({ kunci, dimensi_kode, teks, kalimat_negatif, boleh_tb })),
    terbuka: isi.terbuka, catatan_tambahan: isi.catatan_tambahan, opsi_tb: isi.opsi_tb,
});

export const samaIsi = (a, b) => JSON.stringify(a) === JSON.stringify(b);

// ---------- operasi baris (selalu array baru) ----------
export const barisBaru = (dimensiKode) => ({ kunci: kunciBaru(), dimensi_kode: dimensiKode, teks: "", kalimat_negatif: false, boleh_tb: true });

export const ubahBaris = (butir, i, perubahan) => butir.map((b, j) => (j === i ? { ...b, ...perubahan } : b));

export const hapusBaris = (butir, i) => butir.filter((_, j) => j !== i);

export const sisipSetelah = (butir, i, baris) => [...butir.slice(0, i + 1), baris, ...butir.slice(i + 1)];

export function pindahBaris(butir, i, arah) {
    const j = i + arah;
    if (j < 0 || j >= butir.length) return butir;
    const hasil = [...butir];
    [hasil[i], hasil[j]] = [hasil[j], hasil[i]];
    return hasil;
}

// Hasil "Tempel dari Excel" (respons impor-pratinjau) -> daftar butir baru.
export function terapkanTempel(butir, hasil, mode) {
    const baru = hasil.butir.map((b) => ({ kunci: kunciBaru(), dimensi_kode: b.dimensi_kode, teks: b.teks, kalimat_negatif: b.kalimat_negatif,
                                            boleh_tb: b.boleh_tb !== false }));
    return mode === "tambah_di_akhir" ? [...butir, ...baru] : baru;
}

// ---------- ringkasan & validasi cepat ----------
export function ringkasPerDimensi(isi) {
    return isi.dimensi.map((d) => ({ kode: d.kode, nama: d.nama, jumlah: isi.butir.filter((b) => b.dimensi_kode === d.kode).length }));
}

export const nomorNegatif = (isi) => isi.butir.flatMap((b, i) => (b.kalimat_negatif ? [i + 1] : []));

export const jumlahBolehTb = (isi) => isi.butir.filter((b) => b.boleh_tb !== false).length;

function galatTeks(teks, label, maks) {
    const t = (teks || "").trim();
    if (!t) return `${label}: teks wajib diisi.`;
    if (t.length > maks) return `${label}: teks maksimal ${maks} karakter (sekarang ${t.length}).`;
    if (POLA_HTML.test(t)) return `${label}: teks tidak boleh memuat tag HTML.`;
    if (POLA_KONTROL.test(t)) return `${label}: teks memuat karakter kontrol.`;
    return null;
}

// {baris: {indeks: [pesan]}, umum: [pesan]} -- cermin aturan server utk umpan balik langsung.
export function periksaEditor(isi) {
    const baris = {};
    isi.butir.forEach((b, i) => {
        const g = galatTeks(b.teks, `Butir ${i + 1}`, TEKS_BUTIR_MAKS);
        if (g) baris[i] = [g];
    });
    const umum = [];
    if (!isi.nama.trim()) umum.push("Nama versi wajib diisi.");
    if (isi.label && !POLA_LABEL.test(isi.label)) umum.push(`Label hanya huruf, angka, strip, atau garis bawah (1–${LABEL_MAKS} karakter).`);
    if (!isi.butir.length || isi.butir.length > BUTIR_MAKS) umum.push(`Jumlah butir harus 1 sampai ${BUTIR_MAKS} (sekarang ${isi.butir.length}).`);
    const kosong = ringkasPerDimensi(isi).filter((d) => !d.jumlah).map((d) => d.kode);
    if (kosong.length) umum.push(`Setiap dimensi minimal 1 butir (kosong: ${kosong.join(", ")}).`);
    isi.dimensi.forEach((d) => {
        for (const [nilai, label] of [[d.nama, `Nama dimensi ${d.kode}`], [d.nama_excel, `Nama Excel dimensi ${d.kode}`]]) {
            const g = galatTeks(nilai, label, TEKS_BUTIR_MAKS);
            if (g) umum.push(g);
        }
    });
    isi.terbuka.forEach((t) => {
        const g = galatTeks(t.label, `Isian terbuka ${t.kode}`, TEKS_BUTIR_MAKS);
        if (g) umum.push(g);
    });
    if (isi.opsi_tb?.aktif) {
        for (const [nilai, label, maks] of [[isi.opsi_tb.label, "Label TB", LABEL_TB_MAKS], [isi.opsi_tb.keterangan, "Keterangan TB", KETERANGAN_TB_MAKS]]) {
            const g = galatTeks(nilai, label, maks);
            if (g) umum.push(g);
        }
    }
    if (isi.catatan_tambahan.trim()) {
        const g = galatTeks(isi.catatan_tambahan, "Catatan tambahan", CATATAN_TAMBAHAN_MAKS);
        if (g) umum.push(g);
    }
    return { baris, umum, jumlah: Object.keys(baris).length + umum.length };
}

// Galat server [{bagian, baris, pesan}] -> {baris: {indeks 0-based: [pesan]}, umum: [pesan]}.
export function galatServer(galat) {
    const baris = {};
    const umum = [];
    for (const g of galat || []) {
        if (g.bagian === "butir" && g.baris) (baris[g.baris - 1] = baris[g.baris - 1] || []).push(g.pesan);
        else umum.push(g.pesan);
    }
    return { baris, umum };
}

// Isian editor -> bentuk respons GET /survei/publik/{kode}/butir, utk "Pratinjau formulir" (komponen publik yg SAMA).
export function butirPublikDariEditor(isi, versi) {
    const nomor = new Map(isi.butir.map((b, i) => [b.kunci, i + 1]));
    return {
        versi: isi.label || versi.label,
        skala: { min: versi.skala.min, maks: versi.skala.max, ambang_puas: versi.ambang_puas,
                 label_min: versi.skala.label_min, label_maks: versi.skala.label_max },
        dimensi: isi.dimensi.map((d) => ({
            kode: d.kode, nama: d.nama,
            butir: isi.butir.filter((b) => b.dimensi_kode === d.kode)
                .map((b) => ({ no: nomor.get(b.kunci), teks: b.teks, boleh_tb: !!(isi.opsi_tb?.aktif && b.boleh_tb !== false) })),
        })).filter((d) => d.butir.length),
        opsi_tb: isi.opsi_tb || OPSI_TB_BAWAAN,
        terbuka: isi.terbuka.map((t) => ({ kunci: t.kode, teks: t.label })),
        teks_maks: TEKS_TERBUKA_MAKS,
    };
}

export const teksRingkasanRiwayat = (r) =>
    `${r.jumlah_butir} butir · +${r.ditambah} −${r.dihapus} · ${r.diubah} diubah · ${r.dipindah} pindah dimensi${r.urutan_berubah ? " · urutan berubah" : ""}`;

export const LABEL_AKSI_RIWAYAT = { salin: "Dibuat (salinan)", simpan: "Disimpan", pulihkan: "Dipulihkan" };
